import { TYPES } from 'action-types/user';
import { IUser } from './models';
import { IRoles } from 'utilities/roles';

interface IAction {
    readonly type: string;
    readonly user: IUser;
    readonly roles: IRoles[];
    readonly userPermissions: any;
}

export interface IUserState {
    readonly user: IUser;
    readonly roles: IRoles[];
    readonly rolesAreLoading: boolean;
    readonly userPermissions: any;
}

export const defaultState: IUserState = {
    user: {
        displayableId: '',
        idToken: {
            acr: '',
            aud: '',
            auth_time: 0,
            authenticationSource: '',
            company: '',
            exp: 0,
            family_name: '',
            given_name: '',
            iat: 0,
            idp: '',
            iss: '',
            name: '',
            nbf: 0,
            nonce: '',
            oid: '',
            sub: '',
            userGroups: [],
            ver: '',
            email: '',
        },
        identityProvider: '',
        name: '',
        userIdentifier: ''
    },
    roles: JSON.parse(sessionStorage.getItem('roles') || '[]'),
    rolesAreLoading: false,
    userPermissions: {}
};

export const reducer = (state: IUserState = defaultState, action: IAction): IUserState => {
    switch (action.type) {
        case TYPES.SET_USER:
            return {
                ...state,
                user: action.user,
            };
        case TYPES.GET_UAM_BUSINESS_FUNCTIONS.PENDING:
            return {
                ...state,
                rolesAreLoading: true,
            };
        case TYPES.GET_UAM_BUSINESS_FUNCTIONS.FULFILLED:
            return {
                ...state,
                roles: action.roles,
                rolesAreLoading: false,
            };
        case TYPES.GET_UAM_BUSINESS_FUNCTIONS.REJECTED:
            return {
                ...state,
                rolesAreLoading: false,
            };
        case TYPES.GET_USER_UAM_PERMISSION.PENDING:
            return {
                ...state,
                userPermissions: defaultState.userPermissions,
            };
        case TYPES.GET_USER_UAM_PERMISSION.FULFILLED:
            return {
                ...state,
                userPermissions: action.userPermissions,
            };
        case TYPES.GET_USER_UAM_PERMISSION.REJECTED:
            return {
                ...state,
                rolesAreLoading: defaultState.userPermissions,
            };
        default:
            return state;
    }
};
